import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}stockItems`;

export interface GetStockItemsByRequestLineQueryArgs {
  sparePartRequestLineId: string;
}

export interface StockItemDetailsDto {
  stockItemId: string;
  // Keep the rest of fields flexible until a stricter model is required
  [key: string]: unknown;
}

export const getStockItemsByRequestLineRequest = (
  payload: GetStockItemsByRequestLineQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { requestLineId: payload.sparePartRequestLineId }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getStockItemsByRequestLineQuery = async (
  payload: GetStockItemsByRequestLineQueryArgs,
): Promise<BackResponse<StockItemDetailsDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<StockItemDetailsDto[]>>(
      getStockItemsByRequestLineRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
